export default "__VITE_ASSET__1e00059c__"